<template>
  <div class="main-survey-page">
    <header aria-hidden="true">
      <hr class="full-line-bar" />
      <b-navbar aria-hidden="true">
        <b-navbar-brand
          :to="{ name: 'dashboard' }"
          tabindex="-1"
          aria-hidden="true"
        >
          <img
            class="img-fluid logo mb-1"
            aria-hidden="true"
            src="../assets/logos/logo_inline.svg"
            :alt="labels.teamCultureLogo"
          />
        </b-navbar-brand>
      </b-navbar>
      <div class="message-warning">{{ labels.warningMessage }}</div>
    </header>
    <main class="survey-content">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { prop, pipe, equals, curry, when, pathOr } from 'ramda'
import { hideChat } from '@/helpers/chat'

export default {
  computed: {
    ...mapGetters({
      resources: 'resources',
      surveyError: 'customSurvey/surveyError',
    }),
    labels: function() {
      return {
        warningMessage: this.resources.page.survey.warningMessage,
        teamCultureLogo: this.resources.general.teamCultureLogo,
        logout: this.resources.general.menu.logout,
      }
    },
    surveyId() {
      return this.$route.params.id
    },
    isFromEngagementSurvey() {
      return this.$route.query.origin === 'engagement-survey'
    },
  },
  watch: {
    surveyError(surveyError) {
      const equals409 = curry(equals(409))
      const statusEquals409 = pipe(
        prop('status'),
        parseInt,
        equals409
      )

      when(statusEquals409, this.redirectUnauthorized)(surveyError)
    },
  },
  updated() {
    hideChat()
  },
  created() {
    hideChat()

    if (!this.isFromEngagementSurvey) {
      this.$store.dispatch('customSurvey/cleanCustomSurvey')
    }
  },
  mounted() {
    this.$root.$emit('setPageTitle', { context: this, path: 'custom-survey' })
  },
  methods: {
    redirectUnauthorized(error) {
      this.$router.push({
        name: 'custom-surveys.survey.begin',
        params: {
          type: 'unauthorized',
          nextSurveyDate: pathOr(false, ['data', 'nextSurveyDate'], error),
          message: pathOr(false, ['data', 'message'], error),
        },
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.main-survey-page {
  display: flex;
  flex-direction: column;
  width: 100%;

  header {
    .full-line-bar {
      background: linear-gradient(220deg, #bc161c, #ff000a);
      height: 2px;
      margin: 0;
      width: 100%;
    }

    .navbar {
      .img-fluid {
        width: 190px;
      }

      .menu-options {
        display: inline-block;
        margin: 0;
        padding: 0;
      }
    }

    .message-warning {
      background: map-get($theme-colors, 'yellow');
      color: map-get($theme-colors, 'gray03');
      font-weight: 500;
      padding: 3px;
      font-size: 14px;
      text-align: center;
      width: 100%;

      @media (max-width: 767px) {
        font-size: 12px;
      }
    }
  }

  .survey-content {
    background-image: url(/survey/bg-survey.jpg);
    background-position: center;
    background-size: contain;
    flex-grow: 1;
    overflow: auto;
    position: relative;
  }
}
</style>
